import React from "react";
import avance from "../../Public/assets/img/avance.svg";
import yLogo from "../../Public/assets/img/yLogo.svg";
import flyFinance from "../../Public/assets/img/flyFinance.svg";
import incredFinance from "../../Public/assets/img/incredFinance.svg";
import rightTick from "../../Public/assets/img/rightTick.svg";

const mcaPartnerData = [
  { src: incredFinance, alt: "incredFinance", text: "incredFinance" },
  { src: flyFinance, alt: "flyFinance", text: "flyFinance" },
  { src: yLogo, alt: "yLogo", text: "yLogo" },
  { src: avance, alt: "avance", text: "avance" },
];

function TrustedPartner() {
  return (
    <div className="relative z-10 bg-white shadow-[0px_4px_24px_rgba(0,0,0,0.12)] rounded-[10px] py-7 px-7 mx-4 md:mx-10 -mt-6 lg:my-[100px] xl:px-[134px]">
      {" "}
      <div className="flex justify-center items-center gap-3 mb-4 h-[43px]">
        <img src={rightTick} alt="rightTick" className="w-[36px] h-[36px]" />

        <h2 className="font-IvyJournal font-semibold text-[24px] md:text-[34px] leading-none text-[#162542] translate-y-[2px]">
          Trusted by 100+ Partners
        </h2>
      </div>
      <div className="flex justify-center items-center gap-8 flex-wrap">
        {mcaPartnerData.map((item, index) => (
          <img
            key={index}
            src={item.src}
            alt={item.alt}
            className="h-[48px] md:h-[45px] w-auto object-contain grayscale"
          />
        ))}
      </div>
    </div>
  );
}

export default TrustedPartner;
